import { loadDoorSettingsState } from '../../assets/scripts/service/localStorage-service';
import { doorSettingsStateStore } from '../../assets/scripts/service/redux-service';
const config = require('../../json/config.json');
const svgConfig = require('../../json/svg.json');
const defaultDoor = require('../../json/state/aaec-state.json');

export const startPage = (() => {

	const $startPage = $( '.start-page' );
	const $presetPage = $( '.preset-page' );
	const $customizePageTrigger = $( '.customize-link' );
	const $startApplicationButton = $( '.js-start-application-btn', '.start-page' );
	const $useLastCalculationButton = $( '.js-use-last-calculation-btn', '.start-page' );
	const $openStartPageModal = $('.js-open-startpage-modal', '.start-page');
	const detectIpad = navigator.userAgent.match(/iPad/i) != null;
	const $projectName = $('.result-page__project-name');
	//console.log(detectIpad);

	//Detect if on ipad and landscape mode, then remove product name
	if(detectIpad === true && window.innerHeight < window.innerWidth){
		$projectName.addClass('hide-on-iPad');
	}

	window.addEventListener("orientationchange", function() {
		if(detectIpad === true && window.innerHeight > window.innerWidth){
			$projectName.addClass('hide-on-iPad');
		} else{
			$projectName.removeClass('hide-on-iPad');
		}
	});

	if ( $startPage.is( ":visible" ) ) {
		$('.hamburger').hide();
	}

	//detect if there is a last calculation or not
	$useLastCalculationButton.hide();
	if ( loadDoorSettingsState() !== undefined ) {
		$useLastCalculationButton.show();
	}

	$useLastCalculationButton.on( 'click', function(e){
		e.preventDefault();
		$startPage.hide();
		//$('.assa-abloy-logo').addClass('show');
		if ( $( window ).width() <= 668 ) {
			$('.hamburger').show();
		}
		$( '.sidebar__link' ).removeClass( 'sidebar__link--active' );
		$('.sidebar__link.result-page-link').addClass( 'sidebar__link--active' );

		//launchIntoFullscreen(document.documentElement);

	});

	$startApplicationButton.on( 'click', function(e){
		e.preventDefault();
		//$('.assa-abloy-logo').addClass('show');
		// if there is no state saved in localstorage save the default state on first click on "Start anew calculation" button
		// if there is state saved dont save the default state.
		if ( loadDoorSettingsState() == undefined ) {
			doorSettingsStateStore.dispatch({ type: 'CHANGE_TO_DEFAULT_STATE', defaultObj: defaultDoor });
		}

		$startPage.hide();
		$customizePageTrigger.trigger( 'click' );
		//$customizePage.addClass('is--visible');
		if ( $( window ).width() <= 668 ) {
			$('.hamburger').show();
		}
		$( '.sidebar__link' ).removeClass( 'sidebar__link--active' );
		$('.sidebar__link.js-link[data-panel="customize"]').addClass( 'sidebar__link--active' );

		//launchIntoFullscreen(document.documentElement);

	});

	$openStartPageModal.on('click', function() {
		var mobileWidth = 375;

		var elem = document.getElementById("watch-a-video-iframe");
		if (elem.requestFullscreen && screen.width < mobileWidth) {
			elem.requestFullscreen();
		} else if (elem.mozRequestFullScreen < mobileWidth) {
			elem.mozRequestFullScreen();
		} else if (elem.webkitRequestFullscreen < mobileWidth) {
			elem.webkitRequestFullscreen();
		} else if (elem.msRequestFullscreen < mobileWidth) { 
			elem.msRequestFullscreen();
		}
		const $this = $( this );
		const dataModalAttr = $this.attr( 'data-modal' );
		//const $frame = $('#watch-a-video-iframe');
		//const vidsrc = 'https://player.vimeo.com/video/133124842?color=dc2b35&title=0&byline=0&portrait=0';

		$( '#' + dataModalAttr ).addClass( 'is--visible' ); // modal
		$( '.overlay-popup' ).addClass('is--visible').css('z-index', 99);
		//$frame.attr('src','');
		//$frame.attr('src', vidsrc);
	});

	// $startPage.hide(); console.log('Start Page is hidden to not disturb development flow (Start page needs styling)  ............. ((Remove this line of code to make startpage appear again!))' );
	
})();



// WEBPACK FOOTER //
// ./src/components/start-page/start-page.js